import styled, { css } from "styled-components/macro";

export const ContainerViewChat = styled.div<{
  isActive?: boolean;
}>`
  display: grid;
  grid-template-columns: 270px 1fr;
  margin: 0 auto;
  padding: 64px 8px 4em 8px;
  max-width: ${(props) => props.theme.sizes.maxWidthMainWindow};
  transition: 0.3s all ease;
  @media ${(props) => props.theme.media.leftmenu} {
    grid-template-columns: 1fr;
    margin: 1rem 0;
    padding: 0 1rem 4em 1rem;
  }
  position: relative;
  & label {
    word-break: break-word;
  }

`;

export const ContainerChat = styled.div<{
  isHiden?: boolean;
  isActive?: boolean;
}>`

border-radius: ${(props) => props.theme.sizes.borderRadius};
  border: 1px solid ${(props) => props.theme.colors.border};
  background-color: ${(props) => props.theme.colors.secondary};
  padding: 16px;
  margin: 0;
  max-height: 550px;
  width: 100%;
  display: grid;
  gap: 8px;
  grid-template-areas: "chater-place message-place" "input-place input-place";
  grid-template-columns: 210px 1fr;
  grid-template-rows: minmax(0, 370px) auto;
  ${(props) =>
    props.isHiden &&
    css`
    display: none;
  `}
  & > #input-place {
    grid-area: input-place;
  }
  @media ${(props) => props.theme.media.phone} {
    display: ${(props) => (props.isHiden ? "none" : "flex")};


    
    flex-direction: column;
    justify-content: space-between;
    height: 100vh; 

  & > #chater-place {
    grid-area: chater-place;
    border-right: 1px solid ${(props) => props.theme.colors.border};
    @media ${(props) => props.theme.media.phone} {
      height: ${(props) => (props.isActive ? "max-content" : "100%")};
      border: none;
      & #convSection {
        height: 90%;
      }
      ${(props) =>
    props.isActive &&
    css`
          border-bottom: 1px solid ${(props) => props.theme.colors.border};
          text-align: right;
        `}
    }
  }
  
  & > #message-place {
    grid-area: message-place;
    height: 100%;
  }
  & > #input-place {
    grid-area: input-place;
  }
  

  @media ${(props) => props.theme.media.phone} {
    padding: 8px 8px;
    margin: 1rem 0;
  }



`;

export const RoomPreviewWrapper = styled.div`
position: fixed;
height: 100vh;
width: 100%;
background: rgba(0, 0, 0, 0.5);
left: 0;
top: 0;
display: flex;
justify-content: center;
align-items: center;
z-index: 105;
& > div {
  z-index: 300;
  margin: 0 10px;
  border-radius: 4px;
  background: #FFFCF6;
  padding: 20px;
  height: 80vh;
  overflow-y: scroll;
}
`;

export const Loader = styled.div<{ w?: string, h?: string, b?: string }>`
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  top: ${props => props.w ? '80px' : ''};
  width: 100%;
  height: 30px;
  & div {
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: ${props => props.w ? props.w : '30px'};
  height: ${props => props.h ? props.h : '30px'};
  border: 3px solid ${(props) => props.theme.colors.text};
  border: ${props => props.b ? props.b : `3px solid ${props.theme.colors.text}`};
  margin: 8px;
  border-radius: 50%;
  animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: ${(props) => props.theme.colors.text} transparent transparent transparent;
  }
  & div:nth-child(1) {
  animation-delay: -0.45s;
  }
  & div:nth-child(2) {
  animation-delay: -0.3s;
  }
  & div:nth-child(3) {
  animation-delay: -0.15s;
  }
  @keyframes lds-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

`;


export const ChatWrapper = styled.div<{
  isHiden?: boolean;
  isIOS?: boolean;
  isSafari?: boolean;
  isActive?: boolean;
}>`

max-width: 800px;
width: 100%;
margin: 0 auto;
background-color: ${(props) => props.theme.colors.bgBody};
`;

export const ChatSection = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  background: ${(props) => props.theme.colors.secondary};
  border: 1px solid ${(props) => props.theme.colors.border};
  border-radius: 4px;
  padding: 16px 0 16px 16px;
  margin-top: 16px;
  `;

export const RemovePopover = styled.div`
    position: absolute;
    padding: 24px;  
  `;

export const SelectedConversationTitle = styled.div`
  display: flex;
  align-items: flex-end;
  min-height: 40px;
  max-width: 724px;
  & h2 {
    width: fit-content;
    margin-right: 16px;
    cursor: pointer;
    font-weight: 200;
    &:hover {
      color: ${(props) => props.theme.colors.primary};
    }
  }
  & a {
    color: ${(props) => props.theme.colors.primary};
    font-size: ${(props) => props.theme.font.sizeSubTitle};
    text-decoration: none;
    font-weight: 200;
    margin: 0;
    &:hover {
      color: ${(props) => props.theme.colors.thirdly};
    }
  }
  @media ${(props) => props.theme.media.phone} {
    display: flex;
    align-items: center;
    & > h2 {
      display: inline-block;
      white-space: nowrap;
      max-width: 80%;
    }
    & a {
      display: block;
      padding-left: 2em;
    }
    & svg {
      vertical-align: top;
    }
  }
`;

export const InvitationTitle = styled.div`
text-align: center;
font-weight: 600;
`;

export const InvitationSubTitle = styled.div<{
  fontWeight?: string;
  color?: "main" | "sub";
}>`

`;

export const EmptyLi = styled.li`
  height: 2em;
`;
